














































































import { Component, Vue, Prop } from "vue-property-decorator";
import * as _ from "lodash";
import echarts from "echarts";
import { GetResultAnalysis$ } from "@/request/jxgl";
import MainHeader from "../../../../main/components/main-header/main-header.vue";
import NavLeft from "../../../components/left-nav.vue";
import Danxuan from "./danxuan.vue";
import Duoxuan from "./duoxuan.vue";

@Component({
  components: {
    MainHeader,
    NavLeft,
    Danxuan,
    Duoxuan,
  },
})
export default class KsglAnalysis extends Vue {
  private examId: any = "";
  private result: any = {
    答题内容统计: [],
  };
  private filters: any = {
    current_page: 1,
    total_count: 0,
    total_page: 0,
    page_count: 5,
  };
  private barOption: any = {
    xAxis: {
      type: "category",
      data: [],
    },
    yAxis: {
      name: "(人数)",
      type: "value",
      minInterval: 1,
      data: [],
    },
    grid: {},
    series: [
      {
        type: "bar",
        showBackground: true,
        itemStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            { offset: 0, color: "#FED595" },
            { offset: 0.5, color: "#FEB34D" },
            { offset: 1, color: "#FE950F" },
          ]),
        },
        label: {
          show: true,
          formatter: "{c}",
        },
        data: [],
      },
    ],
  };
  private get currentQuestions() {
    const startIndex =
      (this.filters.current_page - 1) * this.filters.page_count;
    const tempArr = _.cloneDeep(this.result["答题内容统计"]);
    return tempArr.splice(startIndex, this.filters.page_count);
  }
  /**
   * @description 获取分析详情
   */
  private fetchAnalysis() {
    const params: any = {
      params: {
        exam_id: this.examId,
      },
    };
    GetResultAnalysis$(this, params).then((data: any) => {
      this.result = data;
      this.barOption["series"][0]["data"] = this.result["成绩分布图"]["data"];
      this.barOption["xAxis"]["data"] = this.result["成绩分布图"]["name"];
      this.filters.total_count = this.result["答题内容统计"].length;
      this.filters.total_page = Math.ceil(
        this.result["答题内容统计"].length / this.filters.page_count
      );
    });
  }
  /**
   * @description 上一页
   */
  private prev() {
    this.filters.current_page--;
  }
  /**
   * @description 下一页
   */
  private next() {
    this.filters.current_page++;
  }
  /**
   * @description 跳转到某题目所在的页面
   */
  private jumpTo(page) {
    this.filters.current_page = page;
  }
  /**
   * @description 初始化
   */
  private mounted() {
    this.examId = this.$route.query.id;
    this.fetchAnalysis();
  }
}
